import $ from 'jquery';

const MAX_PAGE_COUNT = 3,
    HIDE_CLASS = 'jsHide',
    CURRENT_CLASS = 'currentPage';

function pagination($list, startPostion, onChange) {
    var $children = $list.find('.pageNumbers');
    setVisiblePages($children, startPostion);

    if ($children.length < 6) {
        $list.addClass('is-small');
    }

    $list.on('click', '.pageNumbers', function(e) {
        setPageNumber($(e.target).data('action'));
    });

    function setPageNumber(number) {
        $list.find('.' + CURRENT_CLASS).removeClass(CURRENT_CLASS);
        $list.find('[data-action=' + number + ']').addClass(CURRENT_CLASS);

        setVisiblePages($children, number);

        if ($.isFunction(onChange)) {
            onChange({
                page: number,
                pageCount: $children.length
            });
        }
    }
}

function endPosition(start) {
    return start + MAX_PAGE_COUNT - 1;
}

function filterVisible(start, end) {
    return function(index) {
        var position = index + 1;
        return position >= start && position <= end;
    };
}

function getRange(current, totalCount) {
    var half = Math.floor(MAX_PAGE_COUNT / 2),
        midPoint = (half-1 >= 1) ? half - 1 : 1,
        start = 1,
        end = endPosition(start);

    if (totalCount > MAX_PAGE_COUNT) {
        if (current > midPoint) {
            start = current + half <= totalCount ? current - midPoint : totalCount - MAX_PAGE_COUNT + 1;
            end = endPosition(start);
        }

        if (totalCount < end) {
            start = end - MAX_PAGE_COUNT;
            end = endPosition(start);
        }
    }

    return {
        start: start,
        end: end
    };
}

function setVisiblePages($children, current) {
    var childrenCount = $children.length,
        range = getRange(current, childrenCount);

    $children.parent('li').addClass(HIDE_CLASS);
    $children.filter(filterVisible(range.start, range.end)).parent('li').removeClass(HIDE_CLASS);

    $($children[childrenCount - 1]).parent('li').removeClass(HIDE_CLASS);
    $($children[0]).parent('li').removeClass(HIDE_CLASS);
}

export default pagination;
